"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPropertyCardPhotoWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PropertyCardPhotoWrapperMixin = require("../../mixins/components/PropertyCardPhotoWrapperMixin");
var StyledPropertyCardPhotoWrapper = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledPropertyCardPhotoWrapper",
  componentId: "c11n-8-107-0__sc-1gbptz1-0"
})(["", ""], _PropertyCardPhotoWrapperMixin.PropertyCardPhotoWrapperMixin);
exports.StyledPropertyCardPhotoWrapper = StyledPropertyCardPhotoWrapper;